// src/components/ViewToggle.tsx
import React from 'react';

export enum ViewType {
  BOARD = 'board',
  TABLE = 'table',
  MONTH_VIEW = 'month_view',
  WEEK_VIEW = 'week_view'
}

interface ViewToggleProps {
  currentView: ViewType;
  onViewChange: (view: ViewType) => void;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ currentView, onViewChange }) => {
  return (
    <div className="view-toggle">
      <button
        className={`view-toggle-button ${currentView === ViewType.BOARD ? 'active' : ''}`}
        onClick={() => onViewChange(ViewType.BOARD)}
        title="Board View"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="3" y1="9" x2="21" y2="9"></line>
          <line x1="9" y1="21" x2="9" y2="9"></line>
        </svg>
      </button>
      <button
        className={`view-toggle-button ${currentView === ViewType.TABLE ? 'active' : ''}`}
        onClick={() => onViewChange(ViewType.TABLE)}
        title="Table View"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line>
        </svg>
      </button>
      <button
        className={`view-toggle-button ${currentView === ViewType.MONTH_VIEW ? 'active' : ''}`}
        onClick={() => onViewChange(ViewType.MONTH_VIEW)}
        title="Month View"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
      </button>
      <button
        className={`view-toggle-button ${currentView === ViewType.WEEK_VIEW ? 'active' : ''}`}
        onClick={() => onViewChange(ViewType.WEEK_VIEW)}
        title="Week View"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
          <line x1="3" y1="16" x2="21" y2="16"></line>
        </svg>
      </button>
    </div>
  );
};

export default ViewToggle;